import { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import results from './Resultados.images';
import {
  activeImage,
  arrow,
  container,
  image,
  section,
  title,
  inactiveImage,
  leftArrow,
  rightArrow,
} from './Resultados.styles';

export default function Resultados() {
  const [isMobile, setIsMobile] = useState(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  return (
    <section className={section} id='resultados'>
      <p className={title}>Veja a Transformação em Cada Detalhe</p>

      <div className={container}>
        <div ref={prevRef} className={`${arrow} ${leftArrow}`}>
          <IoIosArrowBack
            size={isMobile ? 30 : 40}
            className={isMobile ? 'text-background' : 'text-title'}
          />
        </div>

        <div ref={nextRef} className={`${arrow} ${rightArrow}`}>
          <IoIosArrowForward
            size={isMobile ? 30 : 40}
            className={isMobile ? 'text-background' : 'text-title'}
          />
        </div>

        <Swiper
          modules={[Navigation]}
          navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          spaceBetween={30}
          slidesPerView={isMobile ? 1 : 3}
          centeredSlides
          speed={800}
          className='rounded-xl'
          loop
        >
          {results.map((src, i) => (
            <SwiperSlide key={i} className='transition-all duration-300'>
              {({ isActive }) => (
                <img
                  src={src}
                  alt={`Resultado ${i + 1}`}
                  draggable={false}
                  onContextMenu={(e) => e.preventDefault()}
                  className={`${image} ${
                    isActive ? activeImage : inactiveImage
                  }`}
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
